class ArticleWarehouse {
    public id: string;
    public agencyId: string;
    public name: string;
    public createdAt: number;

    constructor(
        id: string,
        agencyId: string,
        name: string,
        createdAt: number,
    ) {
        this.id = id;
        this.agencyId = agencyId;
        this.name = name;
        this.createdAt = createdAt;
    }
}

export default ArticleWarehouse;